module.exports = __webpack_public_path__ + "img/silver-dark.93af82d0.png";